"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContext = withContext;
exports.Provider = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _React$createContext = /*#__PURE__*/_react["default"].createContext(),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;

exports.Provider = Provider;

function withContext(Component) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(Consumer, null, function (context) {
      return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, context));
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Sidebar/context.js
// module id = GIDV
// module chunks = 0